module.exports = __webpack_public_path__ + "static/media/dish_card3.0c7a1dc8.png";